export const NOTIFICATION_CODE_QUERY_PARAM = 'notificationCode';